export default "__VITE_ASSET__b12582bd__"